import Vue from 'vue'
import {
  Tabs,
  Table,
  TableColumn,
  Button,
  TabPane,
  Carousel,
  CarouselItem,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui'

Vue.use(Tabs)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.prototype.$message = Message
